export const messages = {
  en: {
    complaintManage: {
      title: 'Complaint Management',
      queryCondition: 'Query Conditions',
      complaintInfo: 'Complaint Information',
      complaintId: 'Complaint ID',
      complaintType: 'Complaint Type',
      complaintName: 'Complainant',
      complaintTel: 'Complainant Phone',
      complaintStatus: 'Complaint Status',
      handler: 'Handler',
      handlerTel: 'Handler Phone',
      operations: 'Operations',
      detail: 'Detail',
      workflow: 'Workflow',
      edit: 'Edit',
      delete: 'Delete',
      confirmDelete: 'Confirm Delete',
      cancel: 'Cancel',
      search: 'Search',
      more: 'More',
      hide: 'Hide',
      addComplaint: 'Add Complaint',
      roomInfo: 'Room Info',
      complaintContent: 'Complaint Content',
      complaintPhotos: 'Complaint Photos',
      processRecords: 'Process Records',
      sequence: 'Sequence',
      processTime: 'Process Time',
      duration: 'Duration',
      opinion: 'Opinion',
      close: 'Close',
      save: 'Save'
    }
  },
  zh: {
    complaintManage: {
      title: '投诉管理',
      queryCondition: '查询条件',
      complaintInfo: '投诉信息',
      complaintId: '投诉编码',
      complaintType: '投诉类型',
      complaintName: '投诉人',
      complaintTel: '投诉电话',
      complaintStatus: '投诉状态',
      handler: '处理人',
      handlerTel: '处理电话',
      operations: '操作',
      detail: '详情',
      workflow: '流程图',
      edit: '修改',
      delete: '删除',
      confirmDelete: '确认删除',
      cancel: '取消',
      search: '查询',
      more: '更多',
      hide: '隐藏',
      addComplaint: '新增投诉',
      roomInfo: '房屋信息',
      complaintContent: '投诉内容',
      complaintPhotos: '投诉图片',
      processRecords: '处理记录',
      sequence: '序号',
      processTime: '处理时间',
      duration: '耗时',
      opinion: '意见',
      close: '关闭',
      save: '保存'
    }
  }
}